import request from "utils/request";

const searchApi = async (query, province, min, max, sort, page, perPage, person) => {
    return await request.get(`/tour/search?query=${query}&province=${province}&min=${min}&max=${max}&sort=${sort}&page=${page}&item=${perPage}&person=${person}`);
};

export {
    searchApi
};
